import videoStyles from '../../shared/stylesheets/video.css'

export const getInitialMuteButton = () => {
  return `
  <button class="${videoStyles['video-mute-button']}">
    ${getMutedButton()}
  </button>
  `    
}

export const getMutedButton = () => {
  return `
    <svg class="${videoStyles['video-mute-svg-muted']}" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#FFF" fill="none" fill-rule="evenodd">
        <path d="M11.1.55l-5.2 5.3h-.2l-4.4.34c-.45.03-.8.43-.8.9v4.8c0 .5.34.88.78.9l4.6.36.14.13 5.06 5.14c.17.14.42 0 .42-.25V.8c0-.24-.25-.37-.4-.25z"/>
        <path d="M20 7l-5 5M15 7l5 5" stroke-linecap="round"/>
      </g>
    </svg>
    <svg class="${videoStyles['video-mute-svg-muted-hover']}" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="evenodd">
        <path d="M10.75.18l-5.1 5.18-4.4.33C.53 5.75 0 6.4 0 7.1v4.8c0 .74.53 1.36 1.25 1.4l4.4.34 5.1 5.18c.5.43 1.25.05 1.25-.63V.77c-.02-.64-.76-1.03-1.25-.6z" fill="#FFF" fill-rule="nonzero"/>
        <path d="M20 7l-5 5M15 7l5 5" stroke="#FFF" stroke-linecap="round"/>
      </g>
    </svg>
  `    
}

export const getUnmutedButton = () => {
  return `
    <svg class="${videoStyles['video-mute-svg-unmuted']}" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">
      <g fill-rule="nonzero" fill="none">
        <path d="M21 9.48c0-3.3-1.82-6.22-4.56-7.48l-.37.87c2.4 1.1 4.02 3.7 4.02 6.6 0 2.96-1.65 5.56-4.1 6.65l.36.88C19.14 15.76 21 12.8 21 9.48z" fill="#FFF"/>
        <path d="M18 9.46C18 7.6 17.06 5.9 15.57 5l-.45.86c1.2.73 1.96 2.1 1.96 3.6 0 1.56-.8 2.96-2.08 3.66l.42.88C17 13.13 18 11.4 18 9.46z" fill="#FFF"/>
        <path d="M11.1.55l-5.2 5.3h-.2l-4.4.34c-.45.03-.8.43-.8.9v4.8c0 .5.34.88.78.9l4.6.36.14.13 5.06 5.14c.17.14.42 0 .42-.25V.8c0-.24-.25-.37-.4-.25z" stroke="#FFF"/>
      </g>
    </svg>
    <svg class="${videoStyles['video-mute-svg-unmuted-hover']}" width="21" height="19" viewBox="0 0 21 19" xmlns="http://www.w3.org/2000/svg">
    
    <g fill-rule="nonzero" fill="#FFF">
      <path d="M21 9.48c0-3.3-1.82-6.22-4.56-7.48l-.37.87c2.4 1.1 4.02 3.7 4.02 6.6 0 2.96-1.65 5.56-4.1 6.65l.36.88C19.14 15.76 21 12.8 21 9.48z"/>
      <path d="M18 9.46C18 7.6 17.06 5.9 15.57 5l-.45.86c1.2.73 1.96 2.1 1.96 3.6 0 1.56-.8 2.96-2.08 3.66l.42.88C17 13.13 18 11.4 18 9.46zM10.75.18l-5.1 5.18-4.4.33C.53 5.75 0 6.4 0 7.1v4.8c0 .74.53 1.36 1.25 1.4l4.4.34 5.1 5.18c.5.43 1.25.05 1.25-.63V.77c-.02-.64-.76-1.03-1.25-.6z"/>
    </g>
  </svg>
  `    
}





// WEBPACK FOOTER //
// ./src/client/utils/muteButtons.js